import React, {useEffect, useState} from 'react';
import {FieldState, FormField, forms} from "../../lib/forms";
import pick from "lodash/pick";
import {IonInput, IonItem, IonLabel} from "@ionic/react";

export interface InputProps {
  definition: FormField,
  onChange: (field: string, value: any) => void;
  onBlur?: (field: string, value: any) => void;
  state: FieldState;
  labelPosition?: 'fixed' | 'stacked' | 'floating' | undefined;
  disabled?: boolean;

  [propName: string]: any;
}

const Input: React.FC<InputProps> = (props) => {
  const [fieldDef, setFieldDef] = useState<FormField>(props.definition);
  const [fieldState, setFieldState] = useState<FieldState>(props.state);
  const [value, setValue] = useState<string>(props.state.value);
  // const fieldName = fieldDef.name;
  
  useEffect(() => {
    // console.log(`RESET STATE: ${fieldName}`, props.state);
    setFieldState(props.state);
  }, [props.state]);

  useEffect(() => {
    // console.log(`RESET DEF: ${fieldName}`);
    setFieldDef(props.definition);
  }, [props.definition]);
  
  const onChange = (e: any) => {
    let value = e.target.value;
    // console.log('onChange', value);

    if (value) {
      if (fieldDef.type === 'telefone')
        value = forms.utils.format.telefone(value);
      else if (fieldDef.type === 'cep')
        value = forms.utils.format.cep(value);
      else if (fieldDef.type === 'currency')
        value = forms.utils.format.currency(value);
      else if (fieldDef.type === 'cnpj')
        value = forms.utils.format.cnpj(value);
    }

    setValue(value);
    props.onChange(fieldDef.name, value);
  };

  const onBlur = (e: any) => {
    if (props.onBlur)
      props.onBlur(fieldDef.name, e.target.value);
  };

  const iprops: any = {};
  switch (fieldDef.type) {
    case "telefone":
      iprops.maxlength = 15;
      iprops.placeholder = '(00) 00000-0000';
      iprops.inputmode = 'numeric';
      break;
    case "cep":
      iprops.maxlength = 9;
      iprops.placeholder = '00000-000';
      iprops.inputmode = 'numeric';
      break;
    case "cnpj":
      iprops.maxlength = 19;  // permitir um digito a mais para poder cortar zeros a esquerda na formatacao
      iprops.placeholder = '00.000.000/0000-00';
      iprops.inputmode = 'numeric';
      break;
  }

  Object.assign(iprops, pick(props, ['maxlength', 'placeholder']));

  // ajustar tipo de campo
  switch (fieldDef.type) {
    case "email":
      iprops.type = 'email';
      break;
    case "number":
      iprops.type = 'number';
      break;
    default:
      iprops.type = 'string';
  }

  // debounce time
  const inputType = fieldDef.type;
  const debounce = inputType === 'cnpj' || inputType === 'telefone' || inputType === 'cep' ||
  inputType === 'currency' ? 500 : 0;

  return (
    <IonItem disabled={props.disabled}>
      <IonLabel
        position={props.labelPosition || 'floating'}
      >
        <span className={(fieldState.touched && fieldState.hasError) ? "text-red-600" : ""}>
          {fieldDef.label} {fieldDef.required && '*'}
        </span>
      </IonLabel>
      <IonInput
        value={value}
        onIonChange={onChange}
        onIonBlur={onBlur}
        debounce={debounce}
        {...iprops}
      />
    </IonItem>
  );
}

export default Input;
